import { useReportsTopNavigationLinks } from './hooks/use-reports-top-navigation-links'
import { useRouteMatch } from 'react-router-dom'
import { Card, Skeleton } from 'antd'
import DetailedReportsPage from './detailed-reports-page'
import TimesheetsPage from 'pages/timesheets/timesheets-page'
import { useSavedReportQuery } from '@timenotes/shared/src/services/saved-reports/queries/use-saved-report-query'

const SAVED_REPORT_PAGE_MAP = {
  report: DetailedReportsPage,
  timesheet: TimesheetsPage,
}

// Extracted reusable logic to not call the navigation hook conditionally
export function SavedReportPageBody() {
  const routeMatch = useRouteMatch<{
    savedReportId: string
  }>()

  const savedReportId = routeMatch.params.savedReportId as string

  const savedReportQuery = useSavedReportQuery({ 
    id: savedReportId
  })

  const savedReport = savedReportQuery.data?.savedReport

  if (!savedReport) {
    return <Loader />
  }

  const Page = SAVED_REPORT_PAGE_MAP[savedReport.kind]

  return (
    <Page 
      savedReport={savedReport}
    />
  )
}

const Loader = () => (
  <>
    <div className="page-content">
      <Skeleton.Button size='large' />
    </div>

    <div className="page-content" style={{ marginLeft: '5px', marginRight: '5px' }}>
      <Card>
        <Skeleton />
      </Card>
    </div>
  </>
)

export function SavedReportPage() {
  useReportsTopNavigationLinks()

  return <SavedReportPageBody />
}